export default __webpack_public_path__ + "static/media/mob_whoarewe.1f7e7216.png";